export class ChangeOrderValidationModel {
    changeOrderName:string;
    engagementId:number
}
